import Vue from 'vue';
import API from '../customers/api';
import QuantityInput from '../customers/components/QuantityInput';

let singleProduct = new Vue({
  components: { QuantityInput },
  el: '#single-product',
  data: {
    quantity: 1,
    buyNow : false,
    product: product,
  },

  computed: {
    shouldAskStockType() {
      return this.product.quantity > 0 && this.product.pin_quantity > 0;
    },

    outOfStock() {
      return this.product.quantity <= 0 && this.product.pin_quantity <= 0;
    },
  },

  mounted() {
    new window.Swiper('.swiper-container', {
      loop: true,
      autoplay: {
        delay: 3000,
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },
    });
  },

  methods: {
    async addToCart(buyNow) {
      this.buyNow = buyNow;

      if (this.shouldAskStockType) {
        $("#add-cart").modal();
        return;
      }

      let type = this.product.pin_quantity > 0 ? "pin" : "goods";
      await this.addProduct(type);
    },

    async addProduct(type) {
      try {
        let response = await API.cart.add(this.product.id, this.quantity, type);
        let item = response.data.items.find(item => item.product_id == this.product.id);
        if (item.out_of_stock) {
          alert(window.trans.out_of_stock);
          return false;
        }

        if (this.buyNow) {
          window.location = window.location = window.routes.checkout;
        } else {
          $('#add-cart').modal('hide');
          alert(window.trans.add_to_cart);
          window.location = window.routes.index;
        }
      } catch(e) {
        if (window.bugsnagClient) {
          window.bugsnagClient.notify(e);
        }
        alert(window.trans.out_of_stock);
        return false;
      }

      return true;
    },
  }
});
